// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { UpdateStatusAllResponseFragment } from '../../fragments/generated/update-status-all-response.fragment.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type UpdateStatusElectronicInvoicesMutationVariables = Types.Exact<{
  invoiceIds: Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input'];
}>;


export type UpdateStatusElectronicInvoicesMutationResult = { __typename?: 'Mutation', updateStatusElectronicInvoices: { __typename?: 'UpdateStatusAllResponseDTO', results: Array<{ __typename?: 'UpdateStatusResultDTO', eInvoiceStatus: Types.EInvoiceStatusEnumDto | null, invoiceId: number }> } };

export const UpdateStatusElectronicInvoicesGql = gql`
    mutation UpdateStatusElectronicInvoices($invoiceIds: [Int!]!) {
  updateStatusElectronicInvoices(invoiceIds: $invoiceIds) {
    ...UpdateStatusAllResponse
  }
}
    ${UpdateStatusAllResponseFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateStatusElectronicInvoicesInjectable extends Apollo.Mutation<UpdateStatusElectronicInvoicesMutationResult, UpdateStatusElectronicInvoicesMutationVariables> {
    override document = UpdateStatusElectronicInvoicesGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */